import React, { useEffect, useState } from 'react';
import { estadoRecorteIA, ouvirRecorteIA } from '../helpers/recorteIA';

// Situação do recorte inteligente (helpers/recorteIA.js) no cabeçalho dos
// editores de catálogo e pôster. Só aparece quando há algo a dizer: o download
// do modelo na primeira vez, ou quando o computador não ajuda.
export default function AvisoRecorteIA() {
  const [e, setE] = useState(estadoRecorteIA);
  useEffect(() => ouvirRecorteIA(setE), []);
  const estilo = { fontSize: '0.78rem' };

  if (e.fase === 'baixando') {
    return (
      <span className="text-muted ms-2" style={estilo}>
        <span className="spinner-border spinner-border-sm me-1" style={{ width: 11, height: 11 }}></span>
        Baixando o recorte inteligente (só na 1ª vez neste computador): {e.pct != null ? `${e.pct}%` : `${e.mb} MB`}
      </span>
    );
  }
  if (e.fase === 'carregando') {
    return (
      <span className="text-muted ms-2" style={estilo}>
        <span className="spinner-border spinner-border-sm me-1" style={{ width: 11, height: 11 }}></span>
        Preparando o recorte inteligente...
      </span>
    );
  }
  if (e.fase === 'falhou') {
    return (
      <span className="ms-2" style={{ ...estilo, color: '#A88A3A' }}
        title="Não deu pra carregar o recorte inteligente neste computador. As fotos estão saindo com o recorte simples (por cor). Recarregue a página pra tentar de novo.">
        <i className="bi bi-exclamation-triangle me-1"></i>Recorte inteligente indisponível: usando o simples
      </span>
    );
  }
  if (e.fase === 'pronto' && e.ep === 'wasm') {
    return (
      <span className="text-muted ms-2" style={estilo}
        title="O navegador não liberou a placa de vídeo, então o recorte roda no processador: cada foto nova leva alguns segundos. Foto já recortada antes abre na hora.">
        <i className="bi bi-cpu me-1"></i>Recorte inteligente sem placa de vídeo (mais lento)
      </span>
    );
  }
  return null;
}
